import React from 'react';
import styles from '../styles/yearlyDiscount.scss';
import { useTranslation } from 'react-i18next';

type YearlyDiscountProps = {
  amount: number;
};

const YearlyDiscount: React.FC<YearlyDiscountProps> = ({ amount }) => {
  const { t } = useTranslation('common', { keyPrefix: 'proTransportSubscriptions' });
  return (
    <div className={styles.yearlyDiscountContainer}>
      <div className={styles.percentText}>
        {t('save')} {amount}%
      </div>
      <div className={styles.yearlyText}>{t('on_yearly_subscription')}</div>
    </div>
  );
};

export default YearlyDiscount;
